import(/* webpackMode: "eager" */ "/vercel/path0/apps/client/app/calculator/bah/page.tsx");
